<template>
  <el-container>
    <el-header>
      <el-page-header title="Home" @back="$router.push('/home').catch(() => { })"
        :content="$t('book-fotos')"></el-page-header>
    </el-header>
    <el-main>
      <el-card shadow="hover">
        <el-form :model="ruleForm" inline="true" :rules="rules" ref="ruleForm">
          <el-form-item :label="$t('periodo')" prop="name">
            <el-date-picker v-model="ruleForm.start" type="daterange" align="right" unlink-panels range-separator="à"
              format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('cliente')" prop="name">
            <el-select v-model="value" placeholder="Select">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('entregador')" prop="name">
            <el-select v-model="value" placeholder="Select">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <el-row gutter="5">
        <el-col :lg="3" v-for="(o) in 8" :key="o">
          <el-card :body-style="{ padding: '0px' }">
            <img src="https://www.xpost.com.br/wp-content/uploads/2019/08/xpost.png" class="image" />
            <div style="padding: 14px;">
              <span>Cliente 1</span>
              <div class="bottom clearfix">
                <time class="time">01/09/2020</time>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import { DepartmentService } from "@/services/department/department.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "BookPhotos",
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      DepartmentService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      var vm = this;
      vm.$router.push("/cadastro/equipe/adicionar").catch(() => { });
    },
    editar: function (id) {
      this.$router.replace({
        name: "packing.edit",
        params: { id: id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-embalagem", { role: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        DepartmentService.delete(id)
          .then((response) => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("embalagem-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      tableData: [],
      ruleForm: {
        start: "",
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  margin-bottom: 10px;
  line-height: 12px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>